import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'u2000-section-title',
    templateUrl: './U2000_sectiontitle.component.html',
    styleUrls: ['./U2000_sectiontitle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class U2000_SectionTitleComponent {
    @Input() label: string;

    constructor() {}
}
